import { render, staticRenderFns } from "./OneColumnBanner.vue?vue&type=template&id=7cb31aad&"
import script from "./OneColumnBanner.vue?vue&type=script&lang=js&"
export * from "./OneColumnBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports